import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { RxIconComponent } from '../rx-icon/rx-icon.component';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'rx-button',
  templateUrl: './rx-button.component.html',
  styleUrls: ['./rx-button.component.scss'],
  imports: [CommonModule, RxIconComponent, MatButtonModule],
  standalone: true,
})
export class RxButtonComponent implements OnInit, AfterViewInit {
  payload: any;

  @Output() clicked: EventEmitter<any> = new EventEmitter();
  @Input() icon = '';
  @Input() color = '';
  @Input() fill = '';
  @Input() type: 'button' | 'submit' = 'button';
  @Input() tabIndex = 0;
  @Input() disabled = false;
  @Input() id = 'item' + Math.random().toString(36).substring(2);
  @Output() disabledChange = new EventEmitter(true);

  @HostBinding('class.disabled')
  get isDisabled() {
    return this.disabled;
  }

  constructor() {}

  ngOnInit() {}

  ngAfterViewInit() {}

  onClick($event) {
    if (this.disabled) {
      $event.preventDefault();
      $event.stopPropagation();
    } else {
      this.clicked.emit($event);
    }
  }
}
